"use client";

import { useState } from "react";
import { ChevronLeft, ChevronRight } from "lucide-react";

const totalPages = 5;

function DoublePageArrow({ direction }) {
  const maskId = `partner-page-arrow-mask-${direction}`;

  return (
    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none" aria-hidden="true">
      <mask id={maskId} style={{ maskType: "alpha" }} maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
        <rect width="24" height="24" fill="#D9D9D9" />
      </mask>
      <g mask={`url(#${maskId})`}>
        <path
          d="M7.00156 18L5.60156 16.6L10.2016 12L5.60156 7.4L7.00156 6L13.0016 12L7.00156 18ZM16.0016 18V6H18.0016V18H16.0016Z"
          fill="currentColor"
          transform={direction === "left" ? "rotate(180 12 12)" : undefined}
        />
      </g>
    </svg>
  );
}

export default function PartnerArticlesPagination() {
  const [currentPage, setCurrentPage] = useState(1);

  const goToPage = (page) => {
    setCurrentPage(Math.min(Math.max(page, 1), totalPages));
  };

  return (
    <nav className="ccp-pagination" aria-label="Partner articles pagination">
      <button
        type="button"
        className="ccp-pagination-icon"
        disabled={currentPage === 1}
        onClick={() => goToPage(1)}
        aria-label="First page"
      >
        <DoublePageArrow direction="left" />
      </button>
      <button
        type="button"
        className="ccp-pagination-box ccp-pagination-prev"
        disabled={currentPage === 1}
        onClick={() => goToPage(currentPage - 1)}
        aria-label="Previous page"
      >
        <ChevronLeft size={18} />
      </button>
      {Array.from({ length: totalPages }, (_, index) => index + 1).map((page) => (
        <button
          type="button"
          key={page}
          className={`ccp-pagination-number${currentPage === page ? " is-active" : ""}`}
          onClick={() => goToPage(page)}
          aria-current={currentPage === page ? "page" : undefined}
          aria-label={`Page ${page}`}
        >
          {page}
        </button>
      ))}
      <button
        type="button"
        className="ccp-pagination-box ccp-pagination-next"
        disabled={currentPage === totalPages}
        onClick={() => goToPage(currentPage + 1)}
        aria-label="Next page"
      >
        <ChevronRight size={18} />
      </button>
      <button
        type="button"
        className="ccp-pagination-icon ccp-pagination-last"
        disabled={currentPage === totalPages}
        onClick={() => goToPage(totalPages)}
        aria-label="Last page"
      >
        <DoublePageArrow direction="right" />
      </button>
    </nav>
  );
}
